var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.remindBindEmailShow
    ? _c("div", { staticClass: "popup" }, [
        _c(
          "div",
          { staticClass: "remind-content", attrs: { id: "remindEmail" } },
          [
            _c("div", { staticClass: "bindEmailUp" }, [
              _c("div", { staticClass: "bindEmailTitle" }, [
                _c("div", { staticClass: "remindTitle" }, [
                  _vm._v(_vm._s(_vm.$t("language.rightTopBanner.bindEmail")))
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "bindEmailClose",
                  on: {
                    click: function($event) {
                      _vm.remindBindEmailShow = false
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "bindEmailBottom" }, [
                _c("div", { staticClass: "gift-des", class: _vm.getClass() }, [
                  _c("div", {
                    staticClass: "des-div",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("language.popup.remindBindEmail.bindEmail")
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "bindEmailButton",
                    on: {
                      click: function($event) {
                        return _vm.openBindEmail()
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "email-inner" }, [
                      _c("div", { staticClass: "ic-email" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: { float: "left", "font-weight": "bold" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.popup.personalCenter.bindEmail")
                            )
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bindEmailDown" }, [
              _c("div", { staticClass: "bindEmailOne" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      float: "left",
                      width: "100%",
                      height: "55Px"
                    }
                  },
                  [
                    _c("div", { staticClass: "box-title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("language.popup.remindBindEmail.coreFeatures")
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "bind-email-bottom" },
                  _vm._l(_vm.bindEmailTextArr, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "bind-email-line",
                        attrs: { title: item }
                      },
                      [
                        _c("div", { staticClass: "bind-email-inner" }, [
                          _vm._v(_vm._s(item))
                        ])
                      ]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "bindEmailTwo" }, [
                _c("div", { staticClass: "box-one" }, [
                  _c("div", { staticClass: "one-top" }, [
                    _c("div", { staticClass: "all-one" }, [
                      _c("div", { staticClass: "box-title" }, [
                        _c("div", { staticClass: "one-color" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "language.popup.remindBindEmail.tourAccount"
                              )
                            )
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "one-bottom" },
                    _vm._l(_vm.tourAccountInfo, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "email-line" },
                        [
                          _c("div", { staticClass: "b-email-inner" }, [
                            item ? _c("div", { staticClass: "gou" }) : _vm._e(),
                            _vm._v(" "),
                            !item
                              ? _c("div", { staticClass: "email-none" }, [
                                  _vm._v("一")
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "bindEmailTwo" }, [
                _c("div", { staticClass: "box-two" }, [
                  _c("div", { staticClass: "two-top" }, [
                    _c("div", { staticClass: "all-one" }, [
                      _c("div", { staticClass: "box-title" }, [
                        _c("div", { staticClass: "two-color" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.emailAccount")))
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "one-bottom" },
                    _vm._l(_vm.EmailAccountInfo, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "email-line" },
                        [
                          _c("div", { staticClass: "b-email-inner" }, [
                            item ? _c("div", { staticClass: "gou" }) : _vm._e()
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8daf7992", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8daf7992","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/personal_center_popups/remind_bind_email_popup.vue
// module id = null
// module chunks = 